import { trpc } from '@web-app/utils/trpc';

/**
 * Fetches previous charting notes for a patient via the shared
 * chartingNotes tRPC router.
 *
 * Returns `PatientChartingNoteRow[]` with resolved title, date, and
 * filtered answers. The ChartHistory component maps this back to the
 * shape ChartingNote/ChartHistoryUI expect.
 */
export const useGetPreviousChartingNotes = (healthieUserId?: number) => {
  const query = trpc.chartingNotes.getByPatientId.useQuery(
    { patientHealthieId: String(healthieUserId) },
    { enabled: !!healthieUserId },
  );

  return {
    data: query.data?.notes,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
